import React from "react";
import {LoginComponent} from "../../components/Login";
import firebase, {googleProvider} from "../../util/firebase";
import {useDispatch} from "react-redux";
import {SetAuthTokenAction, SetUidAction, SetUserInfo} from "../../actions";
import {useHistory} from "react-router";
import {HeaderContainer} from "../Header";
import {login} from "../../util/api";

export const LoginContainer: React.FC = (props: any) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const loginEvent = async () => {
        try {
            await firebase.auth().signInWithPopup(googleProvider);
            const token = await firebase.auth().currentUser!.getIdToken(true);
            const userId = await firebase.auth().currentUser!.uid;
            const userInfo = await login(token);
            dispatch(SetUserInfo(userInfo));
            dispatch(SetAuthTokenAction(token));
            dispatch(SetUidAction(userId));
            const redirectTo = props.location.state
                ? props.location.state.from.pathname
                : "/dock";
            history.push(redirectTo);
        } catch (error) {
            alert("認証に失敗しました。");
            console.error(error);
        }
    };

    return (
        <>
            <HeaderContainer setOpen={() => {}} />
            <LoginComponent loginEvent={loginEvent} />
        </>
    );
};
